module.exports = __webpack_public_path__ + "img/heusler.ee34394b.png";